module.exports = __webpack_public_path__ + "static/media/remove-user-icon.b8018b43.svg";